import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import moment from 'moment';

import { getAppointmentv2 } from 'api/Appointment';

export const useAppointmentv2 = ({ params, appointment, options }) => {
  const navigate = useNavigate();
  const { id } = params;

  const isRecurrence = appointment?.isRecurrence;

  return useQuery(
    ['appointmentv2', parseInt(id)],
    ({ signal }) => getAppointmentv2(navigate, params, signal),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      select: (data) => {
        return {
          ...data,
          appointment:
            data.appointment == -1
              ? data.appointment
              : {
                  ...data.appointment,
                  ...(isRecurrence && {
                    starts_at: moment(appointment.starts_at).toISOString(),
                    ends_at: moment(appointment.starts_at)
                      .set({
                        hour: moment(data.appointment.ends_at).hour(),
                        minute: moment(data.appointment.ends_at).minute(),
                        second: moment(data.appointment.ends_at).second()
                      })
                      .toISOString(),
                    isRecurrence,
                    base_start_date: data.appointment.starts_at
                  })
                }
        };
      },
      ...options
    }
  );
};
